import { Dialog } from 'primereact/dialog';
import React, { useState } from 'react';
import styled from 'styled-components';
import WizardVersionItem from './WizardVersionItem';
import { TextButton } from 'components/v2/buttons';
import FontIcon from 'components/icons/FontIcon';
import { useGetEPDVersions } from 'services/api/queries';
import Tooltip from 'components/controls/Tooltip';

interface Props {
  epdId: string;
}

const WizardVersionHistoryDialog: React.FunctionComponent<Props> = ({ epdId }) => {
  const [isVersionHistoryOpen, setIsVersionHistoryOpen] = useState(false);
  const { data: versions, isLoading, isError } = useGetEPDVersions(epdId, isVersionHistoryOpen);

  const handleVersionClick = () => {
    // Note: Don't prevent event's default behavior and let it open the page in a new tab
    setIsVersionHistoryOpen(false);
  };

  return (
    <>
      <span>
        <TextButton
          type="button"
          text
          icon={<FontIcon icon="simple-wizard-version-log" style={{ fontSize: 24 }} />}
          onClick={() => setIsVersionHistoryOpen(true)}
        />
        <Tooltip position="bottom">Version log</Tooltip>
      </span>
      <StyledDialog
        header="Version log"
        visible={isVersionHistoryOpen}
        style={{ width: 560 }}
        onHide={() => setIsVersionHistoryOpen(false)}
      >
        <DialogContentContainer>
          <InformationContainer>
            Here you can find the version log for this EPD.
            <br />
            The selected EPD version will open in a new tab.
          </InformationContainer>
          {isLoading && <div>Loading...</div>}
          {isError && <div>Failed to load version history.</div>}
          {versions &&
            versions.map((version) => (
              <WizardVersionItem key={version.id} epdId={epdId} data={version} onClick={handleVersionClick} />
            ))}
        </DialogContentContainer>
      </StyledDialog>
    </>
  );
};

const StyledDialog = styled(Dialog)`
  .p-dialog-header {
    padding: 30px 14px;
  }
  .p-dialog-content {
    font-family: 'Inter', sans-serif;
    font-size: 14px;
    line-height: 20px;
  }
  .p-dialog-title {
    margin: 0px !important;
    padding: 0px !important;
  }
  .p-dialog-header-close {
    position: absolute;
    right: 14px;
    top: 14px;
  }
  .p-dialog-header-close svg path {
    fill: ${(props) => props.theme.colors.primaryBlack};
  }
`;

const DialogContentContainer = styled.div`
  padding: 0 2rem 2rem 2rem;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const InformationContainer = styled.div`
  background-color: ${(props) => props.theme.colors.elementsFilledInput};
  color: rgba(21, 21, 21, 0.8);
  text-align: justify;
  padding: 1rem;
  border-radius: 4px;
`;

export default WizardVersionHistoryDialog;
